import { SetStateAction, useEffect } from "react";
import { ModalWithButtons } from "./modal";
import { SkyBlueButton, CustomIconButton, BlueButton } from "../button";
import { useTranslation } from "react-i18next";
import { NeutralColor } from "node-library/dist/colors";
import { useState } from "react";
import { CustomDropdown, CustomTextInput } from "../inputs";
import { sendPOSTRequest } from "../../requestHelper/sendRequest";
import { useSnackbar } from "../toast/showToastMessage";
import { Severity, UserType } from "node-library/dist/constants";
import { GreenTickIcon } from "../toast/successIcons";
import { RedErrorIcon } from "../toast/errorIcons";
import { validateEmail } from "../../helpers/inputHelper";
import { getUserRoles } from "../../helpers/userHelper";
import Config from "../../globals/Config";
import { ButtonTextLoadingAnimation } from "../animation/ButtonLoadingAnimation";
import KeyboardArrowLeftIconRounded from "@mui/icons-material/KeyboardArrowLeft";
import { YellowWarnIcon } from "../toast/warnIcons";
import { BillingInfo, ShippingInfo } from "node-library/dist/portal";

interface Props {
	open: boolean;
	setOpen: React.Dispatch<SetStateAction<boolean>>;
	proceedAction: () => void;
	setUnsavedChanges: React.Dispatch<React.SetStateAction<boolean>>;
	goBackToViewUsersPage: (refresh: boolean) => void;
}

export default function NewRosterUserModal(props: Props) {
	const { t: translation } = useTranslation();
	const { openSnackbar } = useSnackbar();

	const [registrationStep, setRegistrationStep] = useState<number>(0);

	const [email, setEmail] = useState<string>("");
	const [verifyEmail, setVerifyEmail] = useState<string>("");
	const [firstName, setFirstName] = useState<string>("");
	const [lastName, setLastName] = useState<string>("");
	// //client address info
	// const [clientCompanyName, setClientCompanyName] = useState<string>("");
	const [role, setRole] = useState<string>("client");

	// const [address, setAddress] = useState<string>("");
	// const [city, setCity] = useState<string>("");
	// const [province, setProvince] = useState<string>("");
	// const [postalCode, setPostalCode] = useState<string>("");
	// const [country, setCountry] = useState<string>("");
	const [phoneNumber, setPhoneNumber] = useState<string>("");

	// billing info
	const [billingInfo, setBillingInfo] = useState<BillingInfo>({
		name: "",
		company: "",
		address: "",
		city: "",
		postalCode: "",
		province: "",
		country: "",
		phoneNumber: "",
		email: "",
	});

	const [billingErrorMsg, setBillingErrorMsg] = useState<BillingInfo>({
		name: "",
		company: "",
		address: "",
		city: "",
		postalCode: "",
		province: "",
		country: "",
		phoneNumber: "",
		email: "",
	});

	// shipping info
	const [shippingInfo, setShippingInfo] = useState<ShippingInfo>({
		name: "",
		address: "",
		city: "",
		postalCode: "",
		province: "",
		country: "",
		phoneNumber: "",
	});

	const [shippingErrorMsg, setShippingErrorMsg] = useState<ShippingInfo>({
		name: "",
		address: "",
		city: "",
		postalCode: "",
		province: "",
		country: "",
		phoneNumber: "",
	});

	//validations
	const [emailErrorMsg, setEmailErrorMsg] = useState<string>("");
	const [verifyEmailErrorMsg, setVerifyEmailErrorMsg] = useState<string>("");
	const [firstNameErrorMsg, setFirstNameErrorMsg] = useState<string>("");
	const [lastNameErrorMsg, setLastNameErrorMsg] = useState<string>("");
	//client address info
	// const [clientCompanyNameErrorMsg, setClientCompanyNameErrorMsg] =
	// 	useState<string>("");
	const [roleErrorMsg, setRoleErrorMsg] = useState<string>("");

	// const [addressErrorMsg, setAddressErrorMsg] = useState<string>("");
	// const [cityErrorMsg, setCityErrorMsg] = useState<string>("");
	// const [provinceErrorMsg, setProvinceErrorMsg] = useState<string>("");
	// const [postalCodeErrorMsg, setPostalCodeErrorMsg] = useState<string>("");
	// const [countryErrorMsg, setCountryErrorMsg] = useState<string>("");
	const [phoneNumberErrorMsg, setPhoneNumberErrorMsg] = useState<string>("");

	const [loading, setLoading] = useState<boolean>(false);

	const { setUnsavedChanges, goBackToViewUsersPage } = props;

	function goBack() {
		if (registrationStep === 1) {
			setRegistrationStep(0);
		} else if (registrationStep === 2) {
			setRegistrationStep(1);
		} else {
			goBackToViewUsersPage(true);
		}
	}

	const fieldsForRegistrationStepOne: Array<any> = [
		{
			id: "register-email-input",
			label: `${translation("Email")}`,
			inputType: "email",
			value: email,
			setValue: setEmail,
			required: true,
			errorMsg: emailErrorMsg,
			setErrorMsg: setEmailErrorMsg,
		},
		{
			id: "register-confirm-email-input",

			label: `${translation("VerifyEmail")}`,
			inputType: "email",
			value: verifyEmail,
			setValue: setVerifyEmail,
			required: true,
			errorMsg: verifyEmailErrorMsg,
			setErrorMsg: setVerifyEmailErrorMsg,
		},
		{
			id: "register-firstname-input",

			label: `${translation("FirstName")}`,
			inputType: "text",
			value: firstName,
			setValue: setFirstName,
			errorMsg: firstNameErrorMsg,
			setErrorMsg: setFirstNameErrorMsg,
		},
		{
			id: "register-lastname-input",

			label: `${translation("LastName")}`,
			inputType: "text",
			value: lastName,
			setValue: setLastName,
			errorMsg: lastNameErrorMsg,
			setErrorMsg: setLastNameErrorMsg,
		},
		{
			id: "register-phone-input",

			label: `${translation("PhoneNumber")}`,
			inputType: "tel",
			value: phoneNumber,
			setValue: setPhoneNumber,
			required: true,
			errorMsg: phoneNumberErrorMsg,
			setErrorMsg: setPhoneNumberErrorMsg,
		},
	];

	const billingFields = [
		{ id: "name", label: translation("ContactName") },
		{ id: "company", label: translation("CompanyName"), notRequired: true },
		{ id: "email", label: translation("Email") },
		{ id: "phoneNumber", label: translation("Phone") },
		{ id: "address", label: translation("StreetAddress") },
		{ id: "postalCode", label: translation("PostalCodeOrZip") },
		{ id: "city", label: translation("City") },
		{ id: "country", label: translation("Country") },
		{ id: "province", label: translation("ProvinceOrState") },
	];

	const shippingFields = [
		{ id: "name", label: translation("ContactName") },
		{ id: "phoneNumber", label: translation("Phone") },
		{ id: "address", label: translation("StreetAddress") },
		{ id: "postalCode", label: translation("PostalCodeOrZip") },
		{ id: "city", label: translation("City") },
		{ id: "country", label: translation("Country") },
		{ id: "province", label: translation("ProvinceOrState") },
	];

	// const fieldsForRegistrationStepTwo: Array<any> = [
	// 	{
	// 		id: "register-company-name-input",

	// 		label: `${translation("CompanyName")}`,
	// 		inputType: "text",
	// 		value: clientCompanyName,
	// 		setValue: setClientCompanyName,
	// 		errorMsg: clientCompanyNameErrorMsg,
	// 		setErrorMsg: setClientCompanyNameErrorMsg,
	// 	},
	// 	{
	// 		id: "register-address-input",

	// 		label: `${translation("Address")}`,
	// 		inputType: "text",
	// 		value: address,
	// 		setValue: setAddress,
	// 		errorMsg: addressErrorMsg,
	// 		setErrorMsg: setAddressErrorMsg,
	// 	},
	// 	{
	// 		id: "register-city-input",

	// 		label: `${translation("City")}`,
	// 		inputType: "text",
	// 		value: city,
	// 		setValue: setCity,
	// 		errorMsg: cityErrorMsg,
	// 		setErrorMsg: setCityErrorMsg,
	// 	},
	// 	{
	// 		id: "register-postal-code-input",
	// 		label: `${translation("PostalCodeOrZip")}`,
	// 		inputType: "text",
	// 		value: postalCode,
	// 		setValue: setPostalCode,
	// 		errorMsg: postalCodeErrorMsg,
	// 		setErrorMsg: setPostalCodeErrorMsg,
	// 	},
	// 	{
	// 		id: "register-country-input",
	// 		label: `${translation("Country")}`,
	// 		inputType: "text",
	// 		value: country,
	// 		setValue: setCountry,
	// 		errorMsg: countryErrorMsg,
	// 		setErrorMsg: setCountryErrorMsg,
	// 	},
	// 	{
	// 		id: "register-province-input",

	// 		label: `${translation("ProvinceOrState")}`,
	// 		inputType: "text",
	// 		value: province,
	// 		setValue: setProvince,
	// 		errorMsg: provinceErrorMsg,
	// 		setErrorMsg: setProvinceErrorMsg,
	// 	},
	// ];
	// const fieldsForCountryAndProvince = [
	// 	{
	// 		id: "register-country-input",
	// 		label: `${translation("Country")}`,
	// 		inputType: "text",
	// 		value: country,
	// 		setValue: setCountry,
	// 		errorMsg: countryErrorMsg,
	// 		setErrorMsg: setCountryErrorMsg,
	// 	},
	// 	{
	// 		id: "register-province-input",

	// 		label: `${translation("ProvinceOrState")}`,
	// 		inputType: "text",
	// 		value: province,
	// 		setValue: setProvince,
	// 		errorMsg: provinceErrorMsg,
	// 		setErrorMsg: setProvinceErrorMsg,
	// 	},
	// ];

	const roles: UserType[] = [
		UserType.ADMIN,
		UserType.ENGINEER_ADMIN,
		UserType.ENGINEER,
		UserType.SHIPPING,
		UserType.CLIENT,
	];

	function handleStepOneVerify() {
		let hasError: boolean = false;
		for (const field of fieldsForRegistrationStepOne) {
			if (
				field.required &&
				(!field.value || (field.value as string).trim().length == 0)
			) {
				field.setErrorMsg(translation("MissingInformation"));
				hasError = true;
			} else {
				field.setErrorMsg("");
			}
		}

		if (!role || role.trim().length == 0) {
			setRoleErrorMsg(translation("MissingInformation"));
			hasError = true;
		}

		if (hasError) {
			return;
		}

		//additional validations
		if (!validateEmail(email)) {
			setEmailErrorMsg(translation("InvalidEmail"));
			return;
		}
		if (email !== verifyEmail) {
			setVerifyEmailErrorMsg(translation("EmailsDoesNotMatch"));
			return;
		}

		if (phoneNumber.trim().length > 0 && phoneNumber.trim().length < 7) {
			setPhoneNumberErrorMsg("InvalidPhoneNumber");
			return;
		}

		setRegistrationStep(1);
	}

	function handleStepTwoVerify() {
		console.log("handleStepTwoVerify");
		//additional validations
		if (billingInfo.email.trim.length > 0 && !validateEmail(email)) {
			setBillingErrorMsg((prev) => ({
				...prev,
				["email"]: translation("InvalidEmail"),
			}));
			return;
		}

		if (
			billingInfo.phoneNumber.trim().length > 0 &&
			billingInfo.phoneNumber.trim().length < 7
		) {
			setBillingErrorMsg((prev) => ({
				...prev,
				["phoneNumber"]: translation("InvalidPhoneNumber"),
			}));
			return;
		}

		setRegistrationStep(2);
	}

	async function handleSubmit() {
		// let hasError: boolean = false;

		// Simple validation for required fields
		// for (const field of fieldsForRegistrationStepTwo) {
		// 	if (
		// 		field.required &&
		// 		(!field.value || (field.value as string).trim().length == 0)
		// 	) {
		// 		field.setErrorMsg(translation("MissingInformation"));
		// 		hasError = true;
		// 	} else {
		// 		field.setErrorMsg("");
		// 	}
		// }
		// for (const field of fieldsForCountryAndProvince) {
		// 	if (
		// 		field.required &&
		// 		(!field.value || (field.value as string).trim().length == 0)
		// 	) {
		// 		field.setErrorMsg(translation("MissingInformation"));
		// 		hasError = true;
		// 	} else {
		// 		field.setErrorMsg("");
		// 	}
		// }

		//validate country and province
		// if (!country || country.trim().length == 0) {
		// 	setCountryErrorMsg(translation("MissingInformation"));
		// }

		if (
			shippingInfo.phoneNumber.trim().length > 0 &&
			shippingInfo.phoneNumber.trim().length < 7
		) {
			setShippingErrorMsg((prev) => ({
				...prev,
				["phoneNumber"]: translation("InvalidPhoneNumber"),
			}));
			return;
		}

		try {
			setLoading(true);
			const userTimeZone: string =
				Intl.DateTimeFormat().resolvedOptions().timeZone;

			const data = await sendPOSTRequest("/logins/register", {
				userName: email,
				firstName: firstName.trim(),
				lastName: lastName.trim(),
				// clientCompanyName: clientCompanyName.trim(),
				role: role.trim(),
				// address: address.trim(),
				// city: city.trim(),
				// province: province.trim(),
				// country: country.trim(),
				// postalCode: postalCode.trim(),
				phoneNumber: phoneNumber.trim(),
				billingName: billingInfo.name.trim(),
				billingCompany: billingInfo.company.trim(),
				billingAddress: billingInfo.address.trim(),
				billingCity: billingInfo.city.trim(),
				billingProvince: billingInfo.province.trim(),
				billingCountry: billingInfo.country.trim(),
				billingPostalCode: billingInfo.postalCode.trim(),
				billingPhoneNumber: billingInfo.phoneNumber.trim(),
				billingEmail: billingInfo.email.trim(),

				shippingName: shippingInfo.name.trim(),
				shippingAddress: shippingInfo.address.trim(),
				shippingCity: shippingInfo.city.trim(),
				shippingProvince: shippingInfo.province.trim(),
				shippingCountry: shippingInfo.country.trim(),
				shippingPostalCode: shippingInfo.postalCode.trim(),
				shippingPhoneNumber: shippingInfo.phoneNumber.trim(),
				timezone: userTimeZone,
			});

			openSnackbar(
				translation("UserAccountCreated"),
				Severity.SUCCESS,
				undefined,
				<GreenTickIcon />
			);
			clearFieldsAfterSubmission();
			props.setOpen(false);
			setRegistrationStep(0);
			setUnsavedChanges(false);
			goBackToViewUsersPage(true);
		} catch (err: any) {
			if (err.response?.data === "User Already Exists") {
				openSnackbar(
					translation("AccountAlreadyExist"),
					Severity.ERROR,
					translation("AccountAlreadyExistDescription"),
					<RedErrorIcon />
				);
			} else {
				openSnackbar(
					translation("SystemError"),
					Severity.ERROR,
					translation("SystemErrorMsg"),
					<RedErrorIcon />
				);
			}
		} finally {
			setLoading(false);
		}
	}

	const registrationInputsStepOne: Array<React.ReactNode> =
		fieldsForRegistrationStepOne.map((field, index) => {
			return (
				<CustomTextInput
					id={field.id}
					key={field.id}
					value={field.value}
					setValue={(value) => {
						field.setValue(value);
						setUnsavedChanges(true);
					}}
					label={field.label}
					type={field.type}
					required={field.required}
					errorMsg={field.errorMsg}
					setErrorMsg={field.setErrorMsg}
				></CustomTextInput>
			);
		});

	const billingForm: Array<React.ReactNode> = billingFields.map(
		({ id, label }) => (
			<CustomTextInput
				key={id}
				id={`billing-${id}-input`}
				label={label}
				value={billingInfo[id as keyof BillingInfo]}
				setValue={(value) => {
					setBillingInfo((prev) => ({ ...prev, [id]: value }));
					setUnsavedChanges(true);
				}}
				errorMsg={billingErrorMsg[id as keyof BillingInfo]}
				setErrorMsg={(error) =>
					setBillingErrorMsg((prev) => ({ ...prev, [id]: error }))
				}
			/>
		)
	);

	const shippingForm: Array<React.ReactNode> = shippingFields.map(
		({ id, label }) => (
			<CustomTextInput
				key={id}
				id={`shipping-${id}-input`}
				label={label}
				value={shippingInfo[id as keyof ShippingInfo]}
				setValue={(value) => {
					setShippingInfo((prev) => ({ ...prev, [id]: value }));
					setUnsavedChanges(true);
				}}
				errorMsg={shippingErrorMsg[id as keyof ShippingInfo]}
				setErrorMsg={(error) =>
					setShippingErrorMsg((prev) => ({ ...prev, [id]: error }))
				}
			/>
		)
	);
	// const registrationInputsStepTwo: Array<React.ReactNode> =
	// 	fieldsForRegistrationStepTwo.map((field, index) => {
	// 		return (
	// 			<CustomTextInput
	// 				id={field.id}
	// 				key={field.id}
	// 				value={field.value}
	// 				setValue={(value) => {
	// 					field.setValue(value);
	// 					setUnsavedChanges(true);
	// 				}}
	// 				label={field.label}
	// 				type={field.type}
	// 				required={field.required}
	// 				errorMsg={field.errorMsg}
	// 				setErrorMsg={field.setErrorMsg}
	// 			></CustomTextInput>
	// 		);
	// 	});
	//
	const roleSelector: React.ReactNode = (
		<CustomDropdown
			id="role-dropdown"
			label={translation("Role")}
			options={roles.map((value) => {
				return {
					value: value,
					title: getUserRoles(value, translation),
				};
			})}
			value={role}
			setValue={(value) => {
				setRole(value);
				setUnsavedChanges(true);
			}}
			hasError={!role}
		></CustomDropdown>
	);

	const registrationStepOneContent: React.ReactNode = (
		<div className="registration-input-content">
			{registrationInputsStepOne[0]}
			{registrationInputsStepOne[1]}

			<div className="register-grid-row">
				{registrationInputsStepOne[2]}
				{registrationInputsStepOne[3]}
			</div>
			{registrationInputsStepOne[4]}
			{roleSelector}
		</div>
	);

	const registrationStepTwoContent: React.ReactNode = (
		<div className="registration-input-content">
			<div className="typography-heading-04">
				{translation("DefaultBillingInformation")}
			</div>
			<div className="register-grid-row">
				{billingForm[0]}
				{billingForm[1]}
			</div>
			<div className="register-grid-row">
				{billingForm[2]}
				{billingForm[3]}
			</div>
			{billingForm[4]}
			<div className="register-grid-row">
				{billingForm[5]}
				{billingForm[6]}
			</div>
			<div className="register-grid-row">
				{billingForm[7]}
				{billingForm[8]}
			</div>
			{/* <div className="register-grid-row">
				<CountryProvinceSelector
					countryDropdownId={"register-country-input"}
					provinceDropdownId={"register-province-input"}
					selectedCountryName={country}
					setSelectedCountryName={setCountry}
					selectedState={province}
					setSelectedState={setProvince}
				/>
			</div> */}
		</div>
	);

	const registrationStepThreeContent: React.ReactNode = (
		<div className="registration-input-content">
			<div className="typography-heading-04">
				{translation("DefaultShippingInformation")}
			</div>
			<div className="register-grid-row">
				{shippingForm[0]}
				{shippingForm[1]}
			</div>
			{shippingForm[2]}
			<div className="register-grid-row">
				{shippingForm[3]}
				{shippingForm[4]}
			</div>
			<div className="register-grid-row">
				{shippingForm[5]}
				{shippingForm[6]}
			</div>
			{/* <div className="register-grid-row">
				<CountryProvinceSelector
					countryDropdownId={"register-country-input"}
					provinceDropdownId={"register-province-input"}
					selectedCountryName={country}
					setSelectedCountryName={setCountry}
					selectedState={province}
					setSelectedState={setProvince}
				/>
			</div> */}
		</div>
	);
	const registrationStepOneButton: React.ReactNode = (
		<BlueButton
			key="register-next-button"
			id="register-next-button"
			children={translation("Next")}
			size={"flex"}
			onClick={() => {
				handleStepOneVerify();
			}}
		></BlueButton>
	);

	const registrationStepTwoButton: React.ReactNode = (
		<div
			style={{
				display: "grid",
				gridTemplateColumns: "1fr 1fr",
			}}
			key="register-button"
		>
			<SkyBlueButton
				id="register-back-button"
				children={translation("Back")}
				size={"flex"}
				onClick={() => {
					goBack();
				}}
			></SkyBlueButton>
			<BlueButton
				id="register-next-button"
				children={translation("Next")}
				size={"flex"}
				onClick={() => {
					handleStepTwoVerify();
				}}
			></BlueButton>
		</div>
	);

	const registrationStepThreeButton: React.ReactNode = (
		<div
			style={{
				display: "grid",
				gridTemplateColumns: "1fr 1fr",
			}}
			key="register-button"
		>
			<SkyBlueButton
				id="register-back-button"
				children={translation("Back")}
				size={"flex"}
				onClick={() => {
					goBack();
				}}
			></SkyBlueButton>
			<BlueButton
				id="register-next-button"
				children={
					loading ? (
						<ButtonTextLoadingAnimation
							text={translation("Loading")}
						></ButtonTextLoadingAnimation>
					) : (
						translation("SignupAndSendEmail")
					)
				}
				size={"flex"}
				disabled={loading}
				onClick={() => {
					handleSubmit();
				}}
			></BlueButton>
		</div>
	);

	let registrationContent: React.ReactNode = registrationStepOneContent;

	let registrationButton: React.ReactNode = registrationStepOneButton;

	switch (registrationStep) {
		case 0:
			registrationContent = registrationStepOneContent;
			registrationButton = registrationStepOneButton;
			break;
		case 1:
			registrationContent = registrationStepTwoContent;
			registrationButton = registrationStepTwoButton;
			break;
		case 2:
			registrationContent = registrationStepThreeContent;
			registrationButton = registrationStepThreeButton;
			break;
	}

	function clearFieldsAfterSubmission() {
		fieldsForRegistrationStepOne.map((field) => {
			field.setValue("");
		});
		for (const id in billingInfo) {
			setBillingInfo((prev) => ({ ...prev, [id]: "" }));
		}
		for (const id in shippingInfo) {
			setShippingInfo((prev) => ({ ...prev, [id]: "" }));
		}
		setRole("client");
	}

	const modal: React.ReactNode = (
		<ModalWithButtons
			modalWidth={500}
			headerText={translation("CreateAnAccount")}
			open={props.open}
			setOpen={props.setOpen}
			buttons={[
				<div
					key={"registration-button"}
					style={{
						display: "flex",
						flexDirection: "column",
						width: "100%",
					}}
				>
					{registrationButton}
				</div>,
			]}
		>
			<div className="login-container">
				<div className="register-step-indicator-row">
					<div
						style={{
							borderRadius: "1px",
							backgroundColor:
								registrationStep >= 0
									? NeutralColor.NEUTRAL_GREY_900
									: NeutralColor.NEUTRAL_GREY_100,
						}}
					></div>
					<div
						style={{
							borderRadius: "1px",
							backgroundColor:
								registrationStep >= 1
									? NeutralColor.NEUTRAL_GREY_900
									: NeutralColor.NEUTRAL_GREY_100,
						}}
					></div>
					<div
						style={{
							borderRadius: "1px",
							backgroundColor:
								registrationStep >= 2
									? NeutralColor.NEUTRAL_GREY_900
									: NeutralColor.NEUTRAL_GREY_100,
						}}
					></div>
				</div>

				{registrationContent}

				{/* <form onSubmit={handleSubmit}>
				{registrationInputs}

				

				<button type="submit">{translation("Register")}</button>
				<button onClick={() => props.setCurrentPage(CurrentLoginPage.LOGIN)}>
					{translation("Back")}
				</button>
			</form> */}
			</div>
		</ModalWithButtons>
	);

	return modal;
}
